import { render, staticRenderFns } from "./IndexKlaimPd.vue?vue&type=template&id=014eb7b2&"
import script from "./IndexKlaimPd.vue?vue&type=script&lang=js&"
export * from "./IndexKlaimPd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports